<template>
  <div class="weekDetail">
    <div class="weekTitle z-flex">
      <div class="title">
        {{ submitData.hospitalName }}
      </div>
      <div class="fold z-flex-c" @click="handleFold" v-if="!submitData.registerFlag">
        <span>{{ foldConfig[foldStatus].alt }}</span>
        <img :src="foldConfig[foldStatus].src" />
      </div>
    </div>
    <div class="content" v-show="foldStatus === 'expand' && !submitData.registerFlag">
      <template v-if="submitData.weekOption?.length">
        <div
          v-for="(it, index) in submitData.weekOption"
          :key="submitData.drOutpatientInfoId + index"
          class="weekItem"
        >
          <span class="t">{{ weekDay[index] }}</span>
          <span
            :class="['morOreve', { choosenActived: it.morning === true }]"
            @click="clickTag(it, index, 'morning')"
          >
            <auth-img :src="checkSrc" v-if="it.morning === true" class="check" alt="" />
            上午
          </span>
          <span
            :class="['morOreve', { choosenActived: it.evening === true }]"
            @click="clickTag(it, index, 'evening')"
          >
            <auth-img :src="checkSrc" v-if="it.evening === true" class="check" alt="" />
            下午
          </span>
        </div>
      </template>
    </div>
    <div class="footer z-flex-c">
      <div class="del" @click="delHospital" v-if="!submitData.firstHospitalFlag">删除机构</div>
      <div :class="['switch', { close: submitData.registerFlag === 0 }]" @click="switchRegister">
        {{ submitData.registerFlag === 0 ? '关闭预约' : '开启预约' }}
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, defineProps, createVNode, defineEmits } from 'vue'
import { removeOutPatient } from '@/api/chat'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { Modal, message } from 'ant-design-vue'
const weekDay = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']

const checkSrc = require('@/assets/img/work-place/check.png')
const Fold = require('@/assets/img/work-place/fold.png')
const Expand = require('@/assets/img/work-place/expand.png')

const props = defineProps({
  submitData: {
    type: Object,
    default: () => {}
  }
})
const foldConfig = Object.freeze({
  expand: {
    src: Expand,
    alt: '收起'
  },
  fold: {
    src: Fold,
    alt: '展开'
  }
})
const foldStatus = ref('expand')
const emit = defineEmits(['updateSchedule', 'deleteHospital', 'canSchedule'])
// 展开收起操作
const handleFold = () => {
  foldStatus.value = foldStatus.value === 'expand' ? 'fold' : 'expand'
}
const clickTag = (item, index, type) => {
  emit('canSchedule', {
    status: !item[type],
    itemIndex: index,
    type
  })
}

// 删除机构
const delHospital = () => {
  Modal.confirm({
    title: '提示',
    icon: createVNode(ExclamationCircleOutlined),
    content: '确定删除该机构及对应的排班？',
    okText: '确认',
    cancelText: '取消',
    centered: true,
    onOk: () => {
      const { ucDoctorId, drOutpatientInfoId } = props.submitData || {}
      const params = {
        drOutpatientInfoId,
        ucDoctorId
      }
      removeOutPatient(params).then(() => {
        message.success('操作成功')
        setTimeout(() => {
          emit('deleteHospital', drOutpatientInfoId)
        }, 500)
      })
    },
    onCancel: () => {
      //
    }
  })
}
// 切换预约状态 ，复诊预约开关 0 开 1 关
const switchRegister = () => {
  const { registerFlag } = props.submitData
  const _registerFlag = registerFlag === 0 ? 1 : 0
  const weekOption = props?.submitData?.weekOption || []
  let _weekOption = [...weekOption]
  if (_registerFlag) {
    foldStatus.value = 'fold'
    _weekOption = weekOption.map((element, index) => {
      element.morning = false
      element.evening = false
      return element
    })
  }
  emit('updateSchedule', {
    registerFlag: _registerFlag,
    weekOption: _weekOption
  })
}
</script>
<style scoped lang="scss">
.weekDetail {
  background: #ffffff;
  border-radius: 8px;
  padding: 14px 16px 8px 16px;
  margin-bottom: 12px;
  .weekTitle {
    margin-bottom: 12px;
    align-items: flex-start;
    .title {
      font-weight: 500;
      font-size: 16px;
      color: #1c1c1c;
      flex: 1;
      padding-right: 20px;
    }
    .fold {
      width: 48px;
      color: #999999;
      cursor: pointer;
      line-height: 22px;
      font-weight: 400;
      font-size: 14px;
      img {
        width: 16px;
        height: 16px;
      }
    }
  }
  .content {
    .weekItem {
      margin-bottom: 12px;
      display: flex;
      align-items: center;
      font-size: 16px;

      .t {
        margin-right: 27px;
        flex-shrink: 0;
        text-indent: 4px;
        color: #999999;
      }
      .morOreve {
        width: 120px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f7f7f7;
        border: 1px solid #f0f0f0;
        border-radius: 8px;
        cursor: pointer;
        flex-shrink: 0;
        text-align: center;
        margin-right: 20px;
      }

      .choosenActived {
        background: #3f64ff14;
        border: 1px solid #3f64ff99;
        color: #3f64ff;

        .check {
          width: 24px;
          height: 24px;
          margin-right: 6px;
        }
      }
    }
  }
  .footer {
    border-top: 0.5px solid #efefef;
    padding: 12px 0;

    .del {
      font-weight: 400;
      font-size: 14px;
      color: #b2b2b2;
      cursor: pointer;
      padding: 7px 16px 7px 0;
    }
    .switch {
      margin-left: auto;
      background: #1890ff;
      padding: 7px 16px;
      border-radius: 4px;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
      border-radius: 4px;
      cursor: pointer;
      &.close {
        background: #fff;
        color: #fe4837;
        border: 1px solid #fe4837a6;
      }
    }
  }
}
</style>
